import { render } from "./productConfiguration.vue?vue&type=template&id=da7f703c&scoped=true&ts=true"
import script from "./productConfiguration.vue?vue&type=script&lang=ts"
export * from "./productConfiguration.vue?vue&type=script&lang=ts"

import "./productConfiguration.vue?vue&type=style&index=0&id=da7f703c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da7f703c"]])

export default __exports__